import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import BackgroundImg from "../assets/images/customsoftwareDevelopmentImg.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import SoftwareDevelopmentContent from "../components/softwareDevelopmentComponents/softwareDevelopmentContent";

const CustomSoftwareDevelopmentPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground
        insideText={"Custom Software Development"}
        imgPath={BackgroundImg}
      />
      <SoftwareDevelopmentContent />
      <GetInTouch />
      {/* <TestimonialsTravala /> */}
    </div>
  );
};

export default CustomSoftwareDevelopmentPage;
